import { createEffect, createStore, sample } from 'effector/compat'
import * as customerApi from '@api/customer/customer'
import { parseCookies } from 'nookies'
import { createEvent } from 'effector'

export const $isAuthorization = createStore<boolean>(false, { serialize: 'ignore' })

export const checkAuthorizationFx = createEffect<void, boolean, Error>(async () => {
    const cookies = parseCookies()
    if (!cookies.customer_token && !cookies.zdr_auth_token) return false
    const isAuthorization: boolean = await customerApi.checkAuthorization()
    return isAuthorization
})

export const setIsAuthorization = createEvent()
export const resetIsAuthorization = createEvent()

sample({
    clock: setIsAuthorization,
    fn: (): boolean => true,
    target: $isAuthorization
})

sample({
    clock: resetIsAuthorization,
    fn: (): boolean => false,
    target: $isAuthorization
})
sample({
    clock: checkAuthorizationFx.doneData,
    filter: (isAuthorization) => isAuthorization,
    target: setIsAuthorization
})

sample({
    clock: checkAuthorizationFx.fail,
    target: resetIsAuthorization
})
